<script lang="ts">
	import type { CartState } from '../../handlers/cart_state.svelte';
	import type { addresses } from '$lib/tools/graphdb';

	import { MapLibre, Marker, NavigationControl } from 'svelte-maplibre-gl';
	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';

	import { utils } from '$lib/utils/utils.svelte';
	import { Loc } from '$lib/tools/locale.svelte';
	import { cn } from '$lib/utils';

	let { cart_state, saved_addresses }: { cart_state: CartState; saved_addresses: addresses[] } = $props();

	function select_saved(addr: (typeof saved_addresses)[0]) {
		cart_state.variables.destination = { id: addr.id, is_imported: true, city: addr.city };
	}

	const is_saved_address_selected = $derived(cart_state.variables.destination?.is_imported);
</script>

<div
	class="relative h-[300px] w-full rounded border overflow-hidden {is_saved_address_selected
		? 'border-foreground shadow-sm'
		: 'border-border'}"
>
	<MapLibre
		center={[13.1767, 32.7875]}
		zoom={9}
		onload={(event) => {
			event.target?.resize?.();
		}}
		attributionControl={false}
		doubleClickZoom={true}
		trackResize={true}
		scrollZoom={false}
		class="h-full w-full"
		style="https://tiles.openfreemap.org/styles/liberty"
	>
		<NavigationControl position="top-left" />

		{#each saved_addresses as addr}
			<Marker class="cursor-pointer" lnglat={[addr.location.coordinates[0], addr.location.coordinates[1]]}>
				{#snippet content()}
					<button
						use:utils.actions.tooltip={{
							content: `${addr.name}\n${addr.description ?? ''}`,
							showOnCreate: true,
							placement: 'top'
						}}
						onclick={() => select_saved(addr)}
						class={cn(
							'transition-all duration-200 hover:scale-110',
							cart_state.variables.destination?.id === addr.id
								? 'text-primary scale-110 z-50 drop-shadow-xl'
								: 'text-muted-foreground z-10 opacity-80 hover:opacity-100'
						)}
					>
						<LucideIcon name="MapPin" size="40" class="fill-background" />
					</button>
				{/snippet}
			</Marker>
		{/each}
	</MapLibre>
	{#if !is_saved_address_selected}
		<div
			class="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-xs backdrop-blur-sm pointer-events-none"
		>
			{Loc('click_saved_address_to_select')}
		</div>
	{/if}
</div>
